import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, concatMap } from 'rxjs/operators';
import { Action } from 'redux';
import { RemoveTrack } from '../action-creators';
import { RemoveAssetUpload } from '../../assets/action-creators';
import { REMOVE_ASSET_UPLOAD } from '../../assets/actions';
import AppState from '../../state';
import { NoOp } from '@webapp/store/ui/action-creators';


export const removeTrackAfteAssetEpic = (action$: Observable<Action>, $state: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Action, RemoveAssetUpload>(REMOVE_ASSET_UPLOAD),
    withLatestFrom($state),
    concatMap(([action, state]) => action.assetIds
      .map((assetId) => {
        const track = state.tracks.tracks[assetId];

        if (track?.id && track.releaseId === state.release.release?.id) {
          return new RemoveTrack(state.release.release?.id as string, track.id);
        }
        return new NoOp();
      })
    )
  );